import React, { useState, useEffect, useContext } from 'react';

import ReactDOM from 'react-dom';

import Format from '../../../Utils/formatCurrent';

import { textoTiposParcela } from './tiposParcelas';
import { ContextPagamentoCartao } from '../../../services/pagamentoCartao';
import {
  handleTipoParcelas,
  totalParcelasSelecionadas,
  verifyIfParcelHasCompanyDifferent,
} from './functionsParcelasAPagar';

import { ReactComponent as BoletoSimples } from '../../../assets/novosicones/Financeiro/boleto-simples.svg';
import { ReactComponent as BoletoAgrupado } from '../../../assets/novosicones/Financeiro/CartaoCredito/groupedBill.svg';

import {
  ResumoParcelasSelecionadas,
  FirstSection,
  TextoSimples,
  ParcelasSelecionadas,
  ContainerIconeParcela,
  ContainerValorTotal,
  SecondSection,
  ContainerPayment,
  ContainerPaymentMethod,
} from './styledResumoSelecionadas';
import { ButtonPrimary } from '../../StyledComponent';
import { ContextoFinanceiro } from '../../../services/financeiro';

import { checkIsPossiblePayWithPix } from '../../../Utils/PixFunctions';

import AlertErrorMessage from '../ErrorMessage';

import { isShowCard } from '../CardParcela/ResumoBoletosPendentes/functionsCardBoletos';

const ResumoModal = ({
  parcelasSelecionadas,
  consultaDescontoAntecipacao,
  tema,
  contratoSelecionado,
}) => {
  const { handleOpenModalCardPayment, setParcelasCardPayment } = useContext(
    ContextPagamentoCartao
  );
  const { setShowModalGerarPix, setParcelasPix } =
    useContext(ContextoFinanceiro);
  const [totalResumo, setTotalResumo] = useState('');
  const [tipoParcela, setTipoParcela] = useState('');
  const [isParcelsHaveCompanyDifferent, setIsParcelsHaveCompanyDifferent] =
    useState(false);

  const handleCardPayment = () => {
    setParcelasCardPayment(parcelasSelecionadas);
    handleOpenModalCardPayment();
  };

  const handleClickPixPayment = () => {
    setShowModalGerarPix(true);
    setParcelasPix(parcelasSelecionadas);
  };

  const isPossiblePayWithPix = checkIsPossiblePayWithPix(
    parcelasSelecionadas,
    contratoSelecionado
  );

  useEffect(() => {
    setTotalResumo(totalParcelasSelecionadas(parcelasSelecionadas));
    setTipoParcela(handleTipoParcelas(parcelasSelecionadas));

    setIsParcelsHaveCompanyDifferent(
      verifyIfParcelHasCompanyDifferent(parcelasSelecionadas)
    );
  }, [parcelasSelecionadas]);

  return ReactDOM.createPortal(
    <ResumoParcelasSelecionadas className=''>
      {isParcelsHaveCompanyDifferent && (
        <AlertErrorMessage
          title='Atenção:'
          message='Você só pode fazer o pagamento de uma parcela por
            vez.'
          position='absolute'
          top={-57}
          left={0}
          right={0}
        />
      )}
      <FirstSection>
        <TextoSimples>
          Contrato:{' '}
          {contratoSelecionado?.descricaoProduto ??
            contratoSelecionado?.contrato?.descricaoProduto +
              ' - ' +
              contratoSelecionado?.identificador ??
            contratoSelecionado?.contrato?.identificador ??
            ''}{' '}
        </TextoSimples>
        <ParcelasSelecionadas tema={tema}>
          <p>
            Parcelas selecionadas:{' '}
            {parcelasSelecionadas.length.toString().padStart(2, 0)}
          </p>
        </ParcelasSelecionadas>
      </FirstSection>
      <SecondSection>
        <TextoSimples>{textoTiposParcela[tipoParcela]} </TextoSimples>

        <ContainerPayment tema={tema}>
          <ContainerValorTotal>
            <ContainerIconeParcela tema={tema}>
              {parcelasSelecionadas.length > 1 ? (
                <BoletoAgrupado />
              ) : (
                <BoletoSimples />
              )}
            </ContainerIconeParcela>

            <div>
              <span className='labelValorTotal'>Valor total:</span>
              <span className='valorTotal'> {Format(totalResumo)}</span>
            </div>
          </ContainerValorTotal>

          <ContainerPaymentMethod>
            <ButtonPrimary
              width={194}
              tema={tema}
              onClick={() =>
                consultaDescontoAntecipacao(new Date(), parcelasSelecionadas)
              }
              id={'btnPagarComBoleto'}
              disabled={isParcelsHaveCompanyDifferent}
            >
              PAGAR COM BOLETO
            </ButtonPrimary>
            {isShowCard(parcelasSelecionadas) && (
              <ButtonPrimary
                width={194}
                tema={tema}
                onClick={handleCardPayment}
                style={{
                  margin: 'auto 8px',
                }}
                id={'btnPagarComCartao'}
                disabled={isParcelsHaveCompanyDifferent}
              >
                PAGAR COM CARTÃO
              </ButtonPrimary>
            )}

            {contratoSelecionado?.contrato?.pad_Cob_Pix &&
              parcelasSelecionadas.length === 1 &&
              isPossiblePayWithPix && (
                <ButtonPrimary
                  width={194}
                  tema={tema}
                  onClick={handleClickPixPayment}
                  id={'btnPagarComPix'}
                  disabled={isParcelsHaveCompanyDifferent}
                >
                  PAGAR COM PIX
                </ButtonPrimary>
              )}
          </ContainerPaymentMethod>
        </ContainerPayment>
      </SecondSection>
    </ResumoParcelasSelecionadas>,
    document.getElementById('modalResumoParcelasSelecionadas')
  );
};

export default ResumoModal;
